// extracted by mini-css-extract-plugin
export default {"page":"ParkingPage_page__hJjXO"};